import * as React from 'react';
import { useState } from 'react';
import Slider from 'rc-slider';
import styled, { css } from 'styled-components';
import { rem, rgba } from 'polished';
import { __ } from 'react-i18n';
import { FlexColCenter, FlexRowCenter } from '../../Defaults/Flexbox/Flexbox';
import { Table, TableRow, TableTd, TableTh } from '../General/Table';
import { prop } from '../../../utilities';
import { DsiSvgIcon, IconType } from '../General/SvgIcon';

interface Props {
  shops: any;
  nameOfSeller: string;
  hasSortiment?: boolean;
}

export function SellersListItem({ shops, nameOfSeller, hasSortiment }: Props) {
  const hasMoreShops = shops.length > 1;
  const web = shops && shops.length > 0 ? shops[0].web ?? null : null;
  const sortiment =
    shops && shops.length > 0 ? shops[0].short_description ?? null : null;

  const [isOpened, setIsOpened] = hasMoreShops
    ? useState(false)
    : useState(true);

  const store = stores => {
    if (!store) {
      return null;
    }
    if (stores.length === 0) {
      return __('Bez predajní');
    }
    if (stores.length === 1) {
      return (
        <>
          {/* tslint:disable-next-line:jsx-no-lambda */}
          <AddressMain onClick={() => onAdressClick(stores[0])}>
            {`${stores[0].city}, ${stores[0].address}`}
          </AddressMain>
        </>
      );
    }
    return (
      <>
        {__('Viac predajní')}
        <IconCover isOpened={isOpened}>
          <DsiSvgIcon
            icon={IconType.arrowDown}
            alt={isOpened ? __('Skryť predajne') : __('Zobraziť predajne')}
            width={12}
            height={12}
            viewBox="0 0 12 12"
            fill="#414141"
          />
        </IconCover>
      </>
    );
  };

  const handleOpen = () => {
    if (!hasMoreShops) {
      return;
    }
    setIsOpened(!isOpened);
  };

  const openInNewTab = (name, address, city, placeId) => {
    const url = `https://www.google.com/maps/search/?api=1&query=${name},${address},${city}&place_id=${placeId}`;
    const win = window.open(url, '_blank');
    if (win) {
      win.focus();
    }
  };

  const onAdressClick = s => {
    openInNewTab(s.name, s.address, s.city, s.place_id);
  };

  return (
    <>
      <TableRow>
        <StrongTableTd>{nameOfSeller}</StrongTableTd>
        <FlexRowStyledTableTd onClick={handleOpen} hasMoreShops={hasMoreShops}>
          {shops.length === 1 && (
            <DsiSvgIcon
              icon={IconType.locationMarker}
              width={16}
              height={16}
              viewBox="0 0 16 16"
              fill="#aaaaaa"
              marginRight={12}
            />
          )}
          {store(shops)}
        </FlexRowStyledTableTd>
        {hasSortiment && (
          <StyledTableTd>{sortiment ? sortiment : null}</StyledTableTd>
        )}
        <StyledTableTd>
          {web ? (
            <StyledLink
              title={__('Link na stránku predajcu')}
              href={'https://' + web}
              target="_blank"
            >
              {web}
            </StyledLink>
          ) : null}
        </StyledTableTd>
      </TableRow>
      {shops.length > 1 &&
        isOpened &&
        shops.map((s, index) => {
          return (
            <SubTableRow key={index}>
              <StyledTableTd />
              {/* tslint:disable-next-line:jsx-no-lambda */}
              <Address onClick={() => onAdressClick(s)}>
                <DsiSvgIcon
                  icon={IconType.locationMarker}
                  width={16}
                  height={16}
                  viewBox="0 0 16 16"
                  fill="#aaaaaa"
                  marginRight={12}
                />
                <AddressMain>{`${s.city}, ${s.address}`}</AddressMain>
              </Address>
              <StyledTableTd />
              <StyledTableTd />
            </SubTableRow>
          );
        })}
    </>
  );
}

const tdLikeCss = css`
  font-size: ${rem(16)};
  line-height: ${rem(20)};
  color: ${({ theme }) => theme.colors.textPrimary};
  padding: ${rem(18)} 0 ${rem(18)} ${rem(24)};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 25vh;
  width: 25vh;
`;

const StrongTableTd = styled(TableTd)`
  ${tdLikeCss};
  font-weight: 500;
`;

const StyledTableTd = styled(TableTd)<{ hasMoreShops?: boolean }>`
  ${tdLikeCss};
  font-weight: 400;
  cursor: ${props => (props.hasMoreShops ? 'pointer' : 'normal')};
  text-decoration: ${props => (props.hasMoreShops ? 'underline' : 'none')};
`;

const AddressMain = styled.p`
  cursor: pointer;
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 33vh;
  width: 33vh;
  font-weight: 500;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`;

const FlexRowStyledTableTd = styled(StyledTableTd)`
  display: flex;
  flex-flow: row;
  align-items: center;
  max-width: 33vh;
  width: 33vh;
`;

const Address = styled(FlexRowStyledTableTd)`
  cursor: pointer;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`;

const StyledLink = styled.a`
  ${tdLikeCss};
  color: #1e398d;
  text-decoration: underline;
  padding: 0;
`;

const IconCover = styled.div<{ isOpened: boolean }>`
  transform: ${props => (props.isOpened ? `rotate(180deg)` : `rotate(0deg)`)};
  display: inline-block;
  margin-left: ${rem(8)};
`;

const SubTableRow = styled(TableRow)`
  background-color: transparent;
  cursor: pointer;
`;
